const swagger = {
    invalid_zod_type: 'Ungültiger Zod Typ. Überprüfe deine route guard Konfiguration.',
    not_supported_zod_type_for_params: 'Nicht unterstützter Zod Typ für diese Parameter. Überprüfe deine route guard Konfiguration.',
};
export default swagger;
